import { Col, Row } from "antd";
import CardCharts from "../../components/dashboard/CardCharts/CardCharts";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableActions from "../../components/tables/TableActions/TableActions";
import TableEvents from "../../components/tables/TableEvents/TableEvents";
import {
  useFetchDashboardStatisticsQuery,
  useLazyFetchPaginatedDashboardActionsQuery,
  useLazyFetchPaginatedDashboardEventsQuery,
} from "../../features/api/apiSlice";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageDashboard.module.scss";
import Br from "../../components/ui/Br";
import spacing from "../../components/ui/spacingConfig";
import { useCrudEvent } from "../../features/api/crud/hooks/useCrudEvent";

const PageDashboard: React.FC = () => {
  // Fetch events
  const [
    fetchPaginatedEvents,
    { data: eventsData, isFetching: isFetchingEvents },
  ] = useLazyFetchPaginatedDashboardEventsQuery();

  // Fetch actions
  const [
    fetchPaginatedActions,
    { data: actionsData, isFetching: isFetchingActions },
  ] = useLazyFetchPaginatedDashboardActionsQuery();

  // Fetch statistics
  const { data: statistics, isFetching: isFetchingStatistics } =
    useFetchDashboardStatisticsQuery();

  // Event: delete
  const { onDelete: onDeleteEvent, isDeleting: isDeletingEvent } = useCrudEvent(
    {
      fetchEvents: fetchPaginatedEvents,
    },
  );

  // Action: delete
  const { onDelete: onDeleteAction, isDeleting: isDeletingAction } =
    useCrudAction(fetchPaginatedActions);

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <h1>Tableau de bord</h1>
      <Br height={spacing.sm} />
      <Row gutter={spacing.l}>
        <CardCharts
          title="ProgrÃ¨s actions"
          statistics={statistics}
          type="action"
          isFetching={isFetchingStatistics}
        />
        <CardCharts
          title="ProgrÃ¨s Ã©vÃ©nement"
          statistics={statistics}
          type="event"
          isFetching={isFetchingStatistics}
        />
      </Row>
      <Br height={spacing.xl} />
      <Row>
        <Col span={spacing.m}>
          <TableActions
            actionsData={actionsData}
            fetchData={fetchPaginatedActions}
            isLoading={isFetchingActions || isDeletingAction}
            onDelete={onDeleteAction}
          />
        </Col>
      </Row>
      <Br height={spacing.xl} />
      <Row>
        <Col span={spacing.m}>
          <TableEvents
            // eventsData={data}
            eventsData={eventsData}
            fetchData={fetchPaginatedEvents}
            isLoading={isFetchingEvents || isDeletingEvent}
            onDelete={onDeleteEvent}
          />
        </Col>
      </Row>
    </PageLayout>
  );
};

export default PageDashboard;
